import React, { useEffect, useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import AuthService from "../../../Services/ApiServices/AuthService";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import moment from "moment";
import copy from "copy-to-clipboard";

const WithdrawalHistory = () => {

	const [withdrawalHistory, setWithdrawalHistory] = useState("")

	const handleWithdrwalHistory = async () => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.withdrawalHistory();
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				setWithdrawalHistory(result?.data?.reverse());
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	const handleDeleteWithdrawal = async (id) => {
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.deleteWithdrawal(id);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				handleWithdrwalHistory();
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	useEffect(() => {
		handleWithdrwalHistory()
	}, []);

	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container " >
							<div className="row g-3" >

								<div className="col-lg-12" >
									<div className="card  " >

										<div className="card-body" >
											<h4>Withdrawal history</h4>
											<p>Here you can view all your withdrawal requests and their details.</p>
											<div className="table_data" >
												<div className="table-responsive" >
													<table class="table">
														<thead>
															<tr>
																<th>Request ID</th>
																<th>Status</th>
																<th>Amount</th>
																<th>Details</th>
																<th>Withdrawal Address</th>
																<th>Created</th>
																<th>Action</th>

															</tr>
														</thead>
														<tbody>
															{
																withdrawalHistory?.length > 0 ?
																	withdrawalHistory?.map((item, index) => {
																		return (
																			<tr class="alt" key={index}>
																				<td >
																					{item?._id?.slice(0, 8)?.toUpperCase()}

																					<i className="text-black cursor-pointer ri-file-copy-line text-success ms-1" onClick={() => { copy(item?._id); alertSuccessMessage("Copied..") }} ></i>

																				</td>
																				<td class={`fw-bold ${item?.status === "COMPLETED" ? "text-success" : item?.status === "PENDING" ? "text-warning" : "text-danger"}`}>  {item?.status}</td>

																				<td >
																					₮{item?.amount?.toFixed(2)}
																				</td>
																				<td >
																					{item?.chainName || "--------"}
																				</td>
																				<td >{item?.withdrawal_address || "--------"}</td>

																				<td>
																					{moment(item?.createdAt).format('Do MMMM YYYY')}
																					<br />
																					<small>
																						{moment(item?.createdAt).format('h:mm:ss a')}
																					</small>
																				</td>
																				<td><button className="btn btn-danger" disabled={item?.status !== "PENDING"} onClick={() => handleDeleteWithdrawal(item?._id)}><i class="fa-solid fa-trash"></i></button></td>

																			</tr>
																		);
																	}) :
																	<tr>
																		<td colSpan="6" className="text-center" >
																			<div className="favouriteData pt-5">
																				<img src="/assets/images/not_found.svg" className="img-fluid" width="350" height="350" alt="" />
																				{/* <p>No data found</p> */}
																			</div>
																		</td>
																	</tr>
															}
														</tbody>
													</table>
												</div>
											</div>


										</div>

									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default WithdrawalHistory


